import type { FaireProductEntity } from "../../entity_types/product";

export const p_cwtrvfdha6: FaireProductEntity = {
  token: "p_cwtrvfdha6",
  type: "product",
  name: "FGS - Horse Eye Zircon 18K Gold Plated Stainless Steel Ring",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/fac8a64b082ded1e7aae0518bc99b274882eba41535263759ed9985c17c118dc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a4827ee414566c2fcc11e453fb6b8b5248c6f223b566d86bf4938ee91d2c78c8.jpeg",
    "https://cdn.faire.com/fastly/ed73eaba463b535d4cc4dc50783a2afb57a8643aaf5f6bb6e36e854e6503e49c.jpeg",
    "https://cdn.faire.com/fastly/f317948d6acfaad50a9e98aa891162fe54957018da12437117aa5cbf3b181dd9.jpeg",
    "https://cdn.faire.com/fastly/37a26f54dacac4587a0500f4652640f5002332bb9a5e1dc803178d4229b504d7.jpeg",
    "https://cdn.faire.com/fastly/6c32bb5feff0387b15e62a48cd7ef8ed35d459db86b2d26e3a16cbe97d10bc0e.jpeg",
    "https://cdn.faire.com/fastly/a3e64e501c42d945426488dbfcbe10bae154798afbc04770aa77ddb7729c6305.jpeg",
    "https://cdn.faire.com/fastly/8c06a21a4688f55702dde3784afeca404c19fb66d63c7678a5561d5879096a4f.jpeg",
    "https://cdn.faire.com/fastly/8172f021fab1a259508f8badcd117b15763ae04fc3849296dc3ffeec37e86800.jpeg",
    "https://cdn.faire.com/fastly/bfaff5bd8be03eecf591e7469589014392d00e06ecb454c0da479d354ebafacb.jpeg",
    "https://cdn.faire.com/fastly/63ffb68643ec141c6c2e4e67d3f564e83b55e243c76167042f9010721e4c600e.jpeg",
  ],
  priceDollars: 4.37,
  description:
    "• Type: Ring\n• Material: Stainless steel, zircon, 18K gold plated\n• Size of zircon: 7.2mm*13.4mm\n• Process: Vacuum electroplating and manual polishing\n• Surface: High Polish\n• Made of high quality stainless steel, Lead-free, Harmless to Human Body.\n\n• Perfect jewelry gifts",
  tags: [],
  msrpDollars: 12.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:07.178Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
